<template>
	<div class="flow-layout theme mode" :class="[theme, mode]">
		<div class="flow-layout-topbar">
			<transition mode="out-in" name="notification-slide">
				<div v-if="$slots['notification'] && !offline" class="flow-layout-notification">
					<slot name="notification" />
				</div>
				<div v-if="offline" class="flow-layout-notification">
					<div class="display-flex align-items-center j-c-c padding-16 bg-error flex-1 flex-gap-12">
						<Icon name="i-cloud-off" state="white" :effects="false" />
						<p class="paragraph-1 fc-dark fw-bold">No Connection.</p>
					</div>
				</div>
			</transition>
			<div v-if="$slots['navbar']" class="flow-layout-navbar flex-gap-8">
				<slot name="navbar" />
			</div>
		</div>
		<div class="flow-layout-body" :sidebar="$slots['sidebar'] != null" :opensidebar="openSidebar">
			<div v-if="$slots['sidebar']" class="flow-layout-sidebar" :open="openSidebar">
				<div class="flow-sidebar-mobile-trigger mobile">
					<Icon
						v-if="openSidebar"
						name="i-hamburger-close"
						type="filled"
						data-qa-toggle-sidebar-mobile
						@click="closeSidebar()"
					/>
					<Icon
						v-if="openSidebar"
						class="mobile"
						name="cldcvr"
						state="dark"
						type="filled"
						:effects="false"
						size="xxx-large"
					/>
				</div>
				<div v-if="isExpandable" class="flow-sidebar-header">
					<Container :padding="12">
						<Icon
							v-if="openSidebar"
							class="desktop"
							name="i-hamburger-close"
							state="light"
							type="filled"
							data-qa-toggle-sidebar-close
							@click="closeSidebar()"
						/>
						<Icon
							v-if="!openSidebar && isExpandable"
							class="desktop"
							name="i-hamburger"
							state="light"
							type="filled"
							data-qa-toggle-sidebar-open
							@click="toggleSidebar(true)"
						/>
					</Container>
					<slot name="sidebar-header" />
				</div>

				<slot name="sidebar" />
			</div>

			<div v-if="openSidebar" class="sidebar-blackout" @click="closeSidebar()" />
			<div class="flow-layout-content" @click="closeSidebar()">
				<slot />
			</div>
		</div>
		<transition mode="out-in" name="notification-slide">
			<div v-if="$slots['footer']" class="flow-layout-footerbar">
				<slot name="footer" />
			</div>
		</transition>
	</div>
</template>
<script>
import { defineComponent } from "vue";
import Icon from "./../Icon/Icon";
import Container from "./../Container/Container";
import { version } from "../package.json";

export default defineComponent({
	name: "Layout",
	components: {
		Icon,
		Container
	},
	props: {
		theme: {
			type: String,
			default: "dark-theme"
		},
		mode: {
			type: String,
			default: "dark-mode"
		},
		openSidebar: {
			type: Boolean,
			default: false
		},
		isExpandable: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			offline: false
		};
	},
	mounted() {
		window.addEventListener("online", () => (this.offline = false));
		window.addEventListener("offline", () => (this.offline = true));
		// eslint-disable-next-line no-console
		console.log(
			`%c@cldcvr/flow%cv${version}`,
			"background:#161616;color:white;padding:4px 6px 4px 6px;border-radius:4px 0px 0px 4px",
			"background:purple;color:white;padding:4px 6px 4px 6px;border-radius:0px 4px 4px 0px;"
		);
	},
	methods: {
		closeSidebar() {
			this.$emit("update:openSidebar", false);
		},
		toggleSidebar(val) {
			this.$emit("update:openSidebar", val);
		}
	}
});
</script>
<style lang="scss">
div.flow-layout {
	display: flex;
	flex-direction: column;
	background-color: var(--dashboard-background);

	height: 100vh;
	// overflow-y: auto;

	> div.flow-layout-topbar {
		.notification-slide {
			&-enter-to,
			&-leave {
				max-height: 100px;
			}
			&-leave-to,
			&-enter {
				max-height: 0px;
				padding: 0px;
			}
			&-enter-active,
			&-leave-active {
				transition: max-height 0.3s linear;
			}
		}

		> div.flow-layout-notification {
			display: flex;
			align-items: center;
		}

		> div.flow-layout-navbar {
			// padding: 12px 12px 12px 12px;
			height: 52px;
			border-bottom: 1px solid var(--dashboard-border-light);
			display: flex;
			align-items: center;

			.mobile {
				display: none;
			}
			div.flow-user-profile {
				cursor: pointer;
			}
		}
	}

	> div.flow-layout-body {
		display: flex;
		overflow: auto;
		flex: 1;

		> div.flow-layout-sidebar {
			border-right: 1px solid var(--dashboard-border-light);
			display: flex;
			flex-direction: column;
			// align-items: center;
			overflow-y: hidden;
			height: inherit;
			width: 52px;
			flex-shrink: 0;
			.mobile {
				display: none;
			}
			transition: width 0.3s linear;
			&[open] {
				width: 400px;
				> div.flow-sidebar-header {
					flex-direction: row;
				}
			}

			> div.flow-sidebar-header {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				flex-direction: column;
			}

			> div.flow-sidebar-mobile-trigger {
				display: none;
			}

			> div.flow-sidebar-top-section {
				display: flex;
				flex-direction: column;
				overflow-y: auto;

				div.sticky-bt-action {
					position: sticky;
					bottom: -1px;
					background: var(--dashboard-background);
					padding-bottom: 8px;
					margin-right: -8px;
					padding-top: 8px;
					margin-top: 4px !important;
				}
				.sticky-tp-action {
					position: sticky;
					top: 0px;
					background: var(--dashboard-background);
					display: inline-flex;
					align-items: center;
					justify-content: center;
					z-index: 4;
					padding-bottom: 12px;
				}
			}
			> div.flow-sidebar-bottom-section {
				border-top: 4px solid var(--dashboard-border-light);
				display: flex;
				flex-direction: column;
				margin-top: auto;
				flex-shrink: 0;
				div.slab-hierarchy > div.slab-container > div.slab-content {
					flex: 1;
					> div.slab-title {
						width: 100%;
					}
				}
			}

			div.slab-hierarchy > div.slab-container > div.slab-content {
				flex: 1;
				> div.slab-title {
					width: 100%;
				}
			}

			div.flow-new-placeholder {
				width: 36px;
				height: 36px;
				> div.env-plus-container {
					height: 20px;
					width: 20px;
					margin: 0px;
				}
			}

			div.slab-hierarchy > div.slab-container > div.slab-content > div.slab-title {
				padding-left: 8px;
			}

			hr.bottom-separator {
				margin-top: auto;
			}

			.new-project-btn {
				height: 20px;
				width: 20px;
			}
		}
		> div.sidebar-blackout {
			content: "";
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-color: var(--slideout-blackout);
			transition: background 0.3s linear;
			z-index: 92;
			display: none;
		}

		> div.flow-layout-content {
			overflow-y: auto;
			overflow-x: hidden;
			// padding: 12px;
			flex-grow: 1;
			position: relative;
		}
	}

	> div.flow-layout-footerbar {
		border-top: 1px solid var(--dashboard-border-light);
		display: flex;
		align-items: center;
	}
}
@media (max-width: 1025px) and (min-width: 551px) {
	div.flow-layout {
		> div.flow-layout-body {
			> div.flow-layout-sidebar {
				&[open] {
					position: fixed;
					top: 52px;
					left: 0px;
					bottom: 0px;
					background-color: var(--dashboard-background);
					z-index: 100;
				}
			}
			> div.sidebar-blackout {
				display: unset;
				top: 52px;
			}
		}
	}
}
@media (max-width: 550px) {
	div.flow-layout {
		> div.flow-layout-topbar {
			> div.flow-layout-navbar {
				.mobile {
					display: unset;
				}
				.desktop {
					display: none;
				}
			}
		}

		> div.flow-layout-body {
			grid-template-columns: 1fr;
			> div.flow-layout-sidebar {
				display: flex;
				max-width: 0px;
				padding: 0px;
				width: calc(100% - 52px);
				z-index: 100;
				background-color: var(--dashboard-background);
				position: fixed;
				top: 0px;
				bottom: 0px;
				left: 0px;

				transition: max-width 0.3s, padding 0.3s;
				&[open] {
					// display: flex;
					max-width: calc(100% - 52px);
					// padding: 8px;

					> div.flow-sidebar-header {
						> *:not(:first-child) {
							margin-left: 0px;
							margin-top: 0px;
						}
					}
				}

				> div.flow-sidebar-header {
					display: flex;
					align-items: center;
					padding: 14px;

					div.search-input-container {
						margin-left: 0px !important;
					}
				}

				> div.flow-sidebar-mobile-trigger {
					display: flex;
					align-items: center;
					padding: 14px;
					justify-content: space-between;
					border-bottom: 1px solid var(--dashboard-border);
					max-height: 52px;

					> [name="cldcvr-full"] {
						flex: 1 0 auto;
						width: unset;
						svg {
							height: 32px;
							width: unset;
						}
					}
				}

				.mobile {
					display: unset;
					&.display-flex {
						display: flex;
					}
				}
				.desktop {
					display: none;
				}

				> div.flow-sidebar-top-section {
					> div.flow-sidebar-top-section-header {
						position: sticky;
						top: 0;
						z-index: 1;
						margin-left: -12px;
						margin-right: -12px;
						padding: 12px;
						background-color: var(--dashboard-element-light);
						display: flex;
						justify-content: space-between;
						align-items: center;
					}

					> *[selected] {
						position: relative;
						&:nth-child(2) {
							&:after {
								top: 0px;
							}
						}
						&:after {
							content: "";
							position: absolute;
							right: -12px;
							border-top-left-radius: 4px;
							border-bottom-left-radius: 4px;
							top: -10px;
							bottom: 0px;
							border-left: 4px solid var(--dashboard-primary);
						}
					}
				}
				> div.flow-sidebar-bottom-section {
					border-top: 1px solid var(--dashboard-border);
					// padding: 12px;
					overflow-x: hidden;

					> *[selected] {
						position: relative;
						&:after {
							content: "";
							position: absolute;
							right: -12px;
							border-top-left-radius: 4px;
							border-bottom-left-radius: 4px;
							top: -10px;
							bottom: 0px;
							border-left: 4px solid var(--dashboard-primary);
						}
					}
				}
			}
			> div.sidebar-blackout {
				display: unset;
			}
			> div.flow-layout-content {
				grid-area: 1 / 1 / end / end !important;
			}
		}
	}
}
</style>
